const button = document.getElementById("js-print-outcome-summary-page");
button.addEventListener("click", initPrint);
window.addEventListener("afterprint", clearPrintStyles);

let contentMatrixContent;
const contentMatrix = document.getElementById("js-contentMatrix");

function initPrint() {
  const d = new Date();
  contentMatrixContent = contentMatrix.innerHTML; //save for later
  contentMatrix.innerHTML = "<p>Printed " + d.toDateString() + "</p>";
  if (disableStylesheet(false)) {
    window.print();
  } else {
    import("../styles/print/outcome-status-summary.scss")
      .then(() => {})
      .catch(() => {})
      .then(() => {
        // Parcel bug throws error (though css loads), so need to run code after all promises resolve
        // https://github.com/parcel-bundler/parcel/issues/5118
        window.print();
      });
  }
}

function clearPrintStyles() {
  if (contentMatrixContent) {
    contentMatrix.innerHTML = contentMatrixContent;
  }
  disableStylesheet(true);
}

function disableStylesheet(disabled = true) {
  for (const styleSheet of document.styleSheets) {
    if (/outcome-status-summary\.(?:.+)\.css/.test(styleSheet.href)) {
      styleSheet.disabled = disabled;
      return true;
    }
  }
  return false;
}
